import React, { useEffect } from 'react';
import {
  preloadCompletionCelebrationImages,
  STAR_SRC,
  STRIDER_SRC,
} from '@/components/CompletionCelebration/completionCelebrationAssets';

/**
 * Keeps celebration bitmaps in the document and warms decode cache for the whole session.
 * Mount once near the app root (hidden, no layout impact).
 */
const CompletionCelebrationWarmup: React.FC = () => {
  useEffect(() => {
    void preloadCompletionCelebrationImages();
  }, []);

  return (
    <div
      className="completion-celebration-warmup"
      aria-hidden={true}
      hidden
    >
      <img src={STRIDER_SRC} alt="" decoding="sync" loading="eager" />
      <img src={STAR_SRC[1]} alt="" decoding="sync" loading="eager" />
      <img src={STAR_SRC[2]} alt="" decoding="sync" loading="eager" />
    </div>
  );
};

export default CompletionCelebrationWarmup;
